<div class="mobile-menu-wrap">
    <nav>
        <ul class="primary">
            <li>
                <a href="http://nsfas.org.za" (click)="closeNav()" target="_blank">NSFAS</a>
            </li>
            <li>
                <a href="https://www.uwc.ac.za/Students/Financial-Matters/Pages/Financial-Aid.aspx" (click)="closeNav()" target="_blank">Fin Aid</a>
            </li>
            <li>
                <a href="https://www.uwc.ac.za/Students/Admin/Pages/Apply-Online.aspx" (click)="closeNav()" target="_blank">Online Applications</a>
            </li>
            <li>
                <a href="https://www.uwc.ac.za/Faculties/Pages/default.aspx" (click)="closeNav()" target="_blank">Faculties</a>
                <ul class="sub">
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/ART/Pages/Home.aspx" (click)="closeNav()">Faculty of Arts</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/CHS/Pages/Home.aspx" (click)="closeNav()">Faculty of Community and Health Sciences</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/DNT/Pages/Home.aspx" (click)="closeNav()">Faculty of Dentistry</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/EDU/Pages/Home.aspx" (click)="closeNav()">Faculty of Education</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/EMS/Pages/Home.aspx" (click)="closeNav()">Faculty of Economic and Management Sciences</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/LAW/Pages/Home.aspx" (click)="closeNav()">Faculty of Law</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.uwc.ac.za/Faculties/NS/Pages/Home.aspx" (click)="closeNav()">Faculty of Natural Sciences</a>
                    </li>
                </ul>
            </li>
            <li>
                <a href="https://www.uwc.ac.za/Students/Financial-Matters/Pages/Student-Finance.aspx" (click)="closeNav()" target="_blank" >Student Finance</a>
            </li>
            <li>
                <a href="https://www.uwc.ac.za/Pages/Contact_Us.aspx" (click)="closeNav()" target="_blank">Contact</a>
            </li>
        </ul>
    </nav>
</div>